// File: utils/googleSheetService.js

/**
 * Hàm gửi dữ liệu form tới Google Sheet thông qua Google Apps Script Web App.
 *
 * @param {string} webAppUrl - URL của Google Apps Script Web App đã được triển khai.
 * @param {object} formData - Đối tượng chứa dữ liệu form (ví dụ: { hoTen: '...', soDienThoai: '...' }).
 * @param {string} targetSheetName - Tên của sheet trong Google Sheet mà bạn muốn ghi dữ liệu vào.
 * @returns {Promise<object>} - Một Promise giải quyết với kết quả của yêu cầu hoặc bị từ chối nếu có lỗi.
 */
export async function sendDataToGoogleSheet(webAppUrl, formData, targetSheetName) {
    if (!webAppUrl || typeof webAppUrl !== 'string') {
        throw new Error("webAppUrl không hợp lệ. Vui lòng cung cấp URL của Google Apps Script Web App.");
    }
    if (!formData || typeof formData !== 'object') {
        throw new Error("formData không hợp lệ. Vui lòng cung cấp một đối tượng dữ liệu.");
    }
    if (!targetSheetName || typeof targetSheetName !== 'string') {
        throw new Error("targetSheetName không hợp lệ. Vui lòng cung cấp tên sheet.");
    }

    try {
        const dataToSend = {
            ...formData, // Bao gồm tất cả dữ liệu từ form
            sheetName: targetSheetName, // Thêm tên sheet vào dữ liệu gửi đi
        };

        const response = await fetch(webAppUrl, {
            method: 'POST',
            // RẤT QUAN TRỌNG: Sử dụng 'no-cors' mode vì Google Apps Script không trả về CORS headers mặc định.
            // Điều này có nghĩa là bạn sẽ KHÔNG THỂ đọc phản hồi JSON trực tiếp từ `response.json()`
            // hoặc kiểm tra `response.ok` một cách đáng tin cậy.
            // Tuy nhiên, yêu cầu vẫn được gửi thành công và script sẽ chạy.
            mode: 'no-cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend), // Chuyển đối tượng thành chuỗi JSON
        });

        // Với 'no-cors', bạn không thể kiểm tra trạng thái HTTP hoặc đọc body phản hồi.
        // Nếu không có lỗi mạng xảy ra, chúng ta giả định yêu cầu đã được gửi thành công.
        console.log('Yêu cầu gửi dữ liệu đã được gửi đi. Vui lòng kiểm tra Google Sheet của bạn.');

        // Trả về một đối tượng thành công giả định.
        return { success: true, message: 'Yêu cầu gửi dữ liệu đã được khởi tạo thành công.' };

    } catch (error) {
        console.error('Lỗi khi gửi dữ liệu tới Google Sheet:', error);
        // Ném lỗi để component gọi có thể bắt và hiển thị thông báo lỗi
        throw new Error(`Không thể gửi dữ liệu: ${error.message}`);
    }
}